export default __webpack_public_path__ + "static/media/LoginImage.7695a55f.jpg";